const actions = {
    SET_DATA: 'addressTypes/SET_DATA',
    GET_DATA: 'addressTypes/GET_DATA',
};

export default actions
